import { Box, Button, Text } from '@chakra-ui/react'
import React from 'react'

import HeadsetOff from '@/components/assets/HeadsetOff'
import { IShortMessageObject, ISystemAgentVisuals } from '@/types/gigiChat/Chat'
import { IConversation } from '@/types/gigiChat/Conversation'

const ExitLiveAgent: React.FC<{
    isConnected: boolean
    item: IShortMessageObject | IConversation
    getStatusLabel: (promptId: number | null) => string | null
    disconnectAgent: (mode: string) => Promise<void>
    agentInfo: ISystemAgentVisuals | null
}> = ({ isConnected, item, agentInfo, getStatusLabel, disconnectAgent }) => {
    if (!agentInfo?.exitButtonText) {
        return null
    }

    const statusLabel = getStatusLabel(item.userPromptId)

    if (isConnected) {
        return (
            <>
                {statusLabel && (
                    <Text fontSize="12px" color="red" pt="12px">
                        {statusLabel}
                    </Text>
                )}

                <Button
                    variant="outline"
                    size="lg"
                    mb="8px"
                    mt="12px"
                    borderRadius="8px"
                    onClick={() => disconnectAgent(item.settings?.processingStrategyQa.mode || '')}
                >
                    <HeadsetOff color="black" /> {agentInfo?.exitButtonText}
                </Button>
            </>
        )
    }

    return (
        <Box fontSize="xs" pt="12px" pb="8px">
            {agentInfo?.disconnectedSidebarLabel}
        </Box>
    )
}

export default ExitLiveAgent
